import { FC, useEffect, useState } from "react";
import NoData from '../../../assets/images/no_data.png';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { Loader } from "rizzui";
import { LuPowerOff } from "react-icons/lu";

interface preventiveStopsCardProps { 
    data?: any;
}

const PreventiveStopsCard:FC<preventiveStopsCardProps> = ({ data }) => {

    // STATES

    const [Census, setCensus] = useState<any>([]);

    // FETCH DATA

    // FUNCTIONS

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES FORMATEA LOS DATOS PARA EL GRÁFICO
     * @EN FORMATS THE DATA FOR THE CHART
     */
    // -------------------------------------------------------------------------------------------------------------
    const formatData = (data: any) : any => {

        let dataFormatted = data.map((item: any) => ({
            name: item.status,
            value: item.total,
            color: item.color,
        }));
        
        return dataFormatted;

    };
    // -------------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES FORMATEA LOS DATOS PARA EL TOOLTIP
     * @EN FORMATS THE DATA FOR THE TOOLTIP
     */
    //--------------------------------------------------------------------------------------------------------------
    const CustomTooltip = ({ payload }: any) => {
        if (!payload || payload.length === 0) {
            return null;
        }
        return (
            <div className="bg-white dark:bg-gray-800 p-2 rounded shadow-lg" >
                {payload && payload.length > 0 && (
                    <>
                        <p className="text-xs font-semibold text-gray-600">
                            <span className="w-2 h-2 inline-block mr-2" style={{ backgroundColor: payload[0].payload.color }}></span>
                            {payload[0].name} 
                             : 
                            <span className="ms-2">{payload[0].value}</span>
                        </p>
                    </>
                )}
            </div>
        );
    };
    //--------------------------------------------------------------------------------------------------------------

    // USE EFFECTS

    useEffect(() => {
        if (data) {
            if (data.length === 0) {
                setCensus(null);
            } else {
                if (data.data.length === 0 || data.totalAll == 0) {
                    setCensus(null);
                } else {
                    setCensus(formatData(data.data));
                }
            }
        }
    }, [data]);

    // RENDER

    return (
        <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4">
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Paradas</h2>
                    <p className="text-sm text-gray-400 dark:text-gray-300">Número de paradas por estado</p>
                    <p className="text-lg text-gray-400 dark:text-gray-300">Total: {data ? data.totalAll : '0'}</p>
                </div>
                <LuPowerOff className="mt-1 text-primary"/>
            </div>
            <div className="flex items-center justify-center mt-4 flex-col">
                { data ? Census == null ? (
                    <div className="flex items-center flex-col justify-center">
                        <img src={NoData} alt="Logo de Austros" className='max-w-[150px]' />
                        <p className="text-gray-400 dark:text-gray-300">No hay datos disponibles</p>
                    </div>
                )   :  (<>
                    <PieChart width={300} height={200}>
                        <Pie
                            data={Census}
                            cx={150}
                            cy={100}
                            fill="#8884d8"
                            dataKey="value"
                        >
                        {/* @ts-ignore */}
                            {Census.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                        <div className="flex flex-wrap justify-center">
                        {Census.map((item: any, index: number) => (
                            <div key={index} color={item.color} className="m-1 flex items-center flex-col">
                                <div className="flex items-center">
                                    <span style={{ backgroundColor: item.color }} className="w-3 h-3 shadow rounded-full inline-block mr-2"></span>
                                    <span className="text-sm font-semibold text-gray-800 dark:text-white">{item.name}</span>
                                </div>
                                <div className="text-sm text-gray-400 dark:text-gray-300 ms-2">{item.value}</div>
                            </div>
                        ))}
                    </div>
                </>) : (
                    <div className="flex items-center justify-center">
                        <p className="text-gray-400 dark:text-gray-300"><Loader color="primary" size="sm" /></p>
                    </div>
                )}
            </div> 
        </div>
    );
}

export default PreventiveStopsCard;